<template lang="pug">
.row.mt-4(v-if="loaded && compsuption.filter((x) => !x.removed).length != 0")
  .col-12
    h3 Расходы сотрудников
  .col.white_block(v-if="compsuption.filter((x) => !x.removed).length == 0") 
    .not_found На данный момент ни один из сотрудников не создал расход табака.
      span Расход табака сотрудник может оформить в боте.
  .col.white_block(v-if="compsuption.filter((x) => !x.removed).length != 0")
    .row.table_header
      .col-2.text-left Сотрудник
      .col.text-left Расход
      .col-2 Дата
      .col-3.text-right Действия

    .row.table_row(v-for="c of compsuption", v-if="!c.removed")
      .col-2 {{ (employee.find((x) => x.id == c.employee_id) || { name: '- сотрудник удален -' }).name }}
      .col 
        .item(v-for="item of c.list")
          span.name {{ (items.find((x) => x.id == item.id) || { name: '- позиция удалена названия -' }).name }},
            | {{ (items.find((x) => x.id == item.id) || { netto: '0' }).netto }} гр.
          span.amount
            <i class="fal fa-times"></i> 
            | {{ item.amount }}
      .col-2.text-center {{ moment(c.createdAt).locale('ru').calendar() }}
      .col-3.text-right
        button.styled(:disabled="c.loading", @click="acceptCompsuption(c)") Принять
        button.styled.red(
          :disabled="c.loading",
          @click="removeCompsuption(c)",
          style="margin-left: 10px"
        ) 
          i.far.fa-trash-alt(style="margin: 0")
  .col-12.text-right
    button.styled(@click="acceptAllCompsuption()") Принять всё
</template>

<script>
import moment from "moment";
import swal from "sweetalert2";
import apiDriver from "../../../apiDriver";

export default {
  props: ["compsuption", "employee", "items", "loaded"],
  methods: {
    moment,
    async acceptCompsuption(c, clear = false) {
      //   c.loading = true;
      this.$emit("compsuptionSetValue", {
        key: "loading",
        value: true,
        compsumption_id: c.id,
      });
      console.log(c);
      let action = await apiDriver.services.api.post(
        "inventory",
        "store/acceptCompsuption",
        { id: c.id }
      );
      //   c.loading = false;
      this.$emit("compsuptionSetValue", {
        key: "loading",
        value: false,
        compsumption_id: c.id,
      });
      if (!action) {
        this.$toast.error("Ошибка приёма расхода...");
        return;
      }
      this.$toast.success(`Расход успешно учтён!`);
      for (let item of c.list) {
        if (item.amount) {
          //   this.items.find((x) => x.id == item.id).amount -= item.amount;
          this.$emit("applyCompsuption", {
            compsumption_id: c.id,
            item_id: item.id,
            amount: item.amount,
          });
        }
      }
      if (!clear) {
        this.$emit("loadWarehouseTransactions");
      }
    },
    async acceptAllCompsuption() {
      let compsuptions = this.compsuption.filter((x) => !x.removed);
      for (let c of compsuptions) {
        this.$emit("compsuptionSetValue", {
          key: "loading",
          value: true,
          compsumption_id: c.id,
        });
      }
      for (let c of compsuptions) {
        await this.acceptCompsuption(c, true);
      }
      this.$emit("loadWarehouseTransactions");
    },
    async removeCompsuption(c) {
      let e_name = (
        this.employee.find((x) => x.id == c.employee_id) || {
          name: "- сотрудник удален -",
        }
      ).name;
      let e_time = moment(c.createdAt).locale("ru").calendar();
      swal({
        title: "Вы уверены?",
        text: `Удаляем расход, созданный сотрудником ${e_name} ${e_time.toLowerCase()}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Да! Удаляй!",
        cancelButtonText: "Нет, стоп...",
      }).then(async (result) => {
        if (result) {
          //   c.loading = true;
          this.$emit("compsuptionSetValue", {
            key: "loading",
            value: true,
            compsumption_id: c.id,
          });
          let action = await apiDriver.services.api.post(
            "inventory",
            "store/removeCompsuption",
            { id: c.id }
          );
          //   c.loading = false;
          this.$emit("compsuptionSetValue", {
            key: "loading",
            value: false,
            compsumption_id: c.id,
          });
          if (!action) {
            this.$toast.error("Ошибка удаления расхода...");
            return;
          }
          this.$toast.success("Расход удален!");
          //   c.removed = true;
          this.$emit("removeCompsuption", { compsumption_id: c.id });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table_header {
  font-weight: bold;
  text-align: center;
  padding-bottom: 5px;
}

.table_row {
  border-top: 4px solid #f4f3ef;
  margin-top: 5px;
  padding-top: 5px;
}

.item {
  .amount {
    font-weight: bold;
    margin-left: 5px;

    i {
      font-size: 10px;
      position: relative;
      top: -1px;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .table_row {
    border-top: 4px solid #444;
  }
}
</style>